import { useContext, useEffect, useState, useRef } from "react";
import ActiveContext from "./ActiveContext";
import { useMount, useUnmount, useUpdateEffect } from "ahooks";
import general from "../../general";

const datas = [];

const useActiveState = (name) => {
  const [state, setState] = useState(general[name]);
  const isUpdatingRef = useRef(false);

  const activeSetState = (state) => {
    setState((old) => ({ ...old, ...state }));
    if (typeof state === "string") {
      general[name] = state;
    } else {
      general[name] = { ...general[name], ...state };
    }
    let setter = "set" + name.substring(0, 1).toUpperCase() + name.substring(1);
    if (general[setter]) {
      general[setter]();
    }
  };

  useMount(() => {
    datas.push({ name, state, setState, activeSetState });
  });

  useUnmount(() => {
    let index = datas.findIndex((item) => item.setState === setState);
    if (index !== -1) {
      datas.splice(index, 1);
    }
  });

  const active = useContext(ActiveContext);
  useEffect(() => {
    if (active && !isUpdatingRef.current) {
      const currentValue = general[name];
      setState((prevState) => {
        // 深度比较，避免不必要的更新
        if (JSON.stringify(prevState) !== JSON.stringify(currentValue)) {
          return currentValue;
        }
        return prevState;
      });
    }
    let index = datas.findIndex((data) => data.setState === setState);
    if (index !== -1) {
      datas[index].active = active;
    }
  }, [active, name]);

  useUpdateEffect(() => {
    if (isUpdatingRef.current) return;

    isUpdatingRef.current = true;
    datas.forEach((data) => {
      if (data.active && data.name === name && data.setState !== setState) {
        data.setState(state);
      }
    });
    isUpdatingRef.current = false;
  }, [state, name]);

  return [state, activeSetState];
};

export default useActiveState;
